import { useState, useEffect } from "react";

/** Returns remaining seconds until `targetEpochMs`, updating every second. Returns 0 when past. */
export function useCountdown(targetEpochMs: number | undefined): number {
  const [remaining, setRemaining] = useState(() =>
    targetEpochMs ? Math.max(0, Math.ceil((targetEpochMs - Date.now()) / 1000)) : 0,
  );

  useEffect(() => {
    if (!targetEpochMs) {
      setRemaining(0);
      return;
    }

    const tick = () => {
      const secs = Math.max(0, Math.ceil((targetEpochMs - Date.now()) / 1000));
      setRemaining(secs);
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetEpochMs]);

  return remaining;
}

/** Format seconds to MM:SS or H:MM:SS */
export function formatTime(seconds: number): string {
  if (seconds <= 0) return "0:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const mm = h > 0 ? String(m).padStart(2, "0") : String(m);
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
